import { Component, computed, inject, input, InputSignal, Signal } from '@angular/core';
import { IconComponent } from '@kinomap-dev/ng-ui-lib/basics';
import { IconType } from '@kinomap-dev/ng-ui-lib/core';
import { WheelLoader } from '@kinomap-dev/ng-ui-lib/loaders';
import { ColorService } from '../../services/color.service';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

import { TranslateModule } from '@ngx-translate/core';
export type GpsUploadControlStatus = 'pending' | 'in_progress' | 'complete' | 'error';

@Component({
  selector: 'app-gps-upload-control-item',
  imports: [TranslateModule, IconComponent, WheelLoader, UpperFirstLetterPipe],
  template: `
    @if (status() !== 'in_progress') {
      <kin-icon [name]="icon()" [color]="iconColor()" />
    } @else {
      <kin-wheel-loader [size]="24" />
    }

    <p [style.color]="validate() ? neutral500 : neutral900">
      {{ text() | translate | upperFirstLetter }}
    </p>
  `,
  styles: `
    :host {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  `,
})
export class GpsUploadControlItem {
  private colorService: ColorService = inject(ColorService);
  text: InputSignal<string> = input.required();
  status: InputSignal<GpsUploadControlStatus> = input.required();
  validate: InputSignal<boolean> = input.required();
  neutral500: string = this.colorService.neutral500();
  neutral900: string = this.colorService.neutral900();

  icon: Signal<IconType> = computed(() => {
    switch (this.status()) {
      case 'complete':
        return 'g_validate';
      case 'error':
        return 'close';
      default:
        return 'options';
    }
  });

  iconColor: Signal<string> = computed(() => {
    if (this.validate()) return this.colorService.neutral500();
    switch (this.status()) {
      case 'complete':
        return this.colorService.success();
      case 'error':
        return this.colorService.danger500();
      default:
        return this.colorService.neutral900();
    }
  });
}
